// extracted by mini-css-extract-plugin
export var cardBand = "scrollyNew-module--cardBand--56-6T";
export var cardHint = "scrollyNew-module--cardHint--qNzRR";
export var cardHintActive = "scrollyNew-module--cardHintActive--yehjV";
export var cardImg = "scrollyNew-module--cardImg--Rddsb";
export var cardImgWrap = "scrollyNew-module--cardImgWrap--9BlCs";
export var cardInfo = "scrollyNew-module--cardInfo--wGo4+";
export var cardName = "scrollyNew-module--cardName--8f3W4";
export var cardsGrid = "scrollyNew-module--cardsGrid--DbiFA";
export var cardsLabel = "scrollyNew-module--cardsLabel--wVxX5";
export var cardsWrapper = "scrollyNew-module--cardsWrapper--uW1Qh";
export var detailContent = "scrollyNew-module--detailContent--3wK9P";
export var detailContentLabel = "scrollyNew-module--detailContentLabel--UaED6";
export var detailHeader = "scrollyNew-module--detailHeader--f587M";
export var detailInner = "scrollyNew-module--detailInner--6gmcl";
export var detailPanel = "scrollyNew-module--detailPanel--Rvn6O";
export var detailPanelOpen = "scrollyNew-module--detailPanelOpen--Zqa06";
export var dwContainer = "scrollyNew-module--dwContainer--cR0gP";
export var hallCard = "scrollyNew-module--hallCard--SNf1g";
export var panelFade = "scrollyNew-module--panelFade--p9FYa";
export var vizSource = "scrollyNew-module--vizSource--xHxMf";
export var wrapper = "scrollyNew-module--wrapper--aqfPq";